export default "__VITE_ASSET__332780f4__"